import { inheritsLoose as _inheritsLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as time from 'd3-time';
import { withTheme } from 'styled-components';
import AxisTicks from './AxisTicks.js';
import AxisLine from './AxisLine.js';
import Label from './Label.js';

var _XAxis;
var XAxis = withTheme((// eslint-disable-next-line zillow/react/prefer-stateless-function
_XAxis = /*#__PURE__*/function (_Component) {
  function XAxis() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(XAxis, _Component);
  var _proto = XAxis.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      xAxisClassName = _this$props.xAxisClassName,
      xAxisOffset = _this$props.xAxisOffset,
      height = _this$props.height,
      xAxisTickCount = _this$props.xAxisTickCount,
      xAxisTickInterval = _this$props.xAxisTickInterval,
      xOrient = _this$props.xOrient,
      margins = _this$props.margins,
      width = _this$props.width,
      tickFormatting = _this$props.tickFormatting,
      _this$props$tickStrok = _this$props.tickStroke,
      tickStroke = _this$props$tickStrok === void 0 ? this.props.theme.constellation.colors.textDark : _this$props$tickStrok,
      tickTextStroke = _this$props.tickTextStroke,
      tickSize = _this$props.tickSize,
      xScale = _this$props.xScale,
      stroke = _this$props.stroke;
    var t = "translate(0 ," + (xAxisOffset + height) + ")";
    var tickArguments;
    if (typeof xAxisTickCount !== 'undefined') {
      tickArguments = [xAxisTickCount];
    }
    if (typeof xAxisTickInterval !== 'undefined') {
      tickArguments = [time[xAxisTickInterval.unit], xAxisTickInterval.interval];
    }
    return /*#__PURE__*/React.createElement("g", {
      className: xAxisClassName,
      transform: t
    }, /*#__PURE__*/React.createElement(Label, {
      label: "",
      offset: 10,
      orient: xOrient,
      margins: margins,
      width: width
    }), /*#__PURE__*/React.createElement(AxisTicks, {
      tickFormatting: tickFormatting,
      tickArguments: tickArguments,
      tickStroke: tickStroke,
      tickTextStroke: tickTextStroke,
      innerTickSize: tickSize,
      scale: xScale,
      orient: xOrient
    }), /*#__PURE__*/React.createElement(AxisLine, _extends({
      scale: xScale,
      stroke: stroke,
      orient: xOrient,
      outerTickSize: tickSize
    }, this.props)));
  };
  return XAxis;
}(Component), _XAxis.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.number.isRequired,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.string,
  tickStroke: PropTypes.string,
  xAxisClassName: PropTypes.string,
  xAxisOffset: PropTypes.number,
  xScale: PropTypes.func.isRequired,
  xOrient: PropTypes.oneOf(['top', 'bottom']),
  xAxisTickCount: PropTypes.number,
  xAxisTickInterval: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  margins: PropTypes.object,
  width: PropTypes.number,
  tickFormatting: PropTypes.func,
  tickTextStroke: PropTypes.string,
  tickSize: PropTypes.number,
  // eslint-disable-next-line zillow/react/forbid-prop-types
  theme: PropTypes.object
}, _XAxis.defaultProps = {
  fill: 'none',
  stroke: 'none',
  strokeWidth: 'none',
  xAxisClassName: 'rd3-x-axis',
  xAxisOffset: 0,
  xOrient: 'bottom'
}, _XAxis));
var XAxis$1 = XAxis;

export { XAxis$1 as default };
